import { gql } from '@apollo/client'
import employeeTagInfoFragment from '../ranking/fragments/employeeTagInfoFragment'

export const EMPLOYEES_AND_TAGS = gql`
  query EmployeesAndTags($companyId: HashedId!, $country: Country!) {
    employeesAndTags(companyId: $companyId, country: $country) {
      id
      firstName
      lastName
      currentLevel
      avatarUrl
      buName
      companyName
      tags {
        id
        type
        addedDate
        removedDate
        note
        temporary
      }
    }
  }
`

export const TAG_HISTORY_OF_EMPLOYEE = gql`
  query tagHistoryOfEmployee($employeeId: HashedId!, $start: DateTime, $end: DateTime, $types: [EmployeeTagType!]) {
    tagHistoryOfEmployee(employeeId: $employeeId, start: $start, end: $end, types: $types) {
      ...EmployeeTagInfo
    }
  }

  ${employeeTagInfoFragment}
`

export const TAG_HISTORY_OF_EMPLOYEE_UNTIL_REPLY_ENTRY_DATE = gql`
  query tagHistoryOfEmployeeUntilReplyEntryDate($employeeId: HashedId!, $types: [EmployeeTagType!]) {
    tagHistoryOfEmployeeUntilReplyEntryDate(employeeId: $employeeId, types: $types) {
      ...EmployeeTagInfo
    }
  }

  ${employeeTagInfoFragment}
`

export const EMPLOYEE_HAS_ONGOING_APPRAISAL = gql`
  query EmployeeHasOngoingAppraisal($employeeId: HashedId!) {
    employeeHasOngoingAppraisal(replyerId: $employeeId)
  }
`

export const EMPLOYMENT_STATUS_OF_EMPLOYEE = gql`
  query EmploymentStatusOfEmployee($employeeId: HashedId!) {
    employmentStatusOfEmployee(employeeId: $employeeId) {
      openChanges
      futureChangesForeseenByContract
      currentBonusAfterFirstJanuary
    }
  }
`
